export const styles = () => ({
  root: {
    padding: 24,
    margin: 0,
  },
})
